function CheckIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44">
      <path
        d="M11.25 23.4375L18.75 30.9375L34.6875 15"
        fill="none"
        stroke="#181818"
        strokeWidth="4.6875"
      />
    </svg>
  );
}

export default CheckIcon;
